export default __webpack_public_path__ + "static/media/pig.8fdebc33.jpg";